import { render, staticRenderFns } from "./DeleteStylistConfirmDialog.vue?vue&type=template&id=678fbffa&scoped=true"
import script from "./DeleteStylistConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteStylistConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteStylistConfirmDialog.vue?vue&type=style&index=0&id=678fbffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fbffa",
  null
  
)

export default component.exports